import CREATE_EVENT_ACTIVITY from './CreateActivity.graphql'
import CREATE_EVENT_FLIGHT from './CreateFlight.graphql'
import CREATE_EVENT_INFO from './CreateInfo.graphql'
import CREATE_EVENT_LODGING from './CreateLodging.graphql'
import CREATE_EVENT_TRANSPORTATION from './CreateTransportation.graphql'

import UPDATE_EVENT_ACTIVITY from './UpdateActivity.graphql'
import UPDATE_EVENT_FLIGHT from './UpdateFlight.graphql'
import UPDATE_EVENT_INFO from './UpdateInfo.graphql'
import UPDATE_EVENT_LODGING from './UpdateLodging.graphql'
import UPDATE_EVENT_TRANSPORTATION from './UpdateTransportation.graphql'

import DELETE_CONTENT_POI from './DeleteContentPOI.graphql'

export default {
  CREATE_EVENT_ACTIVITY,
  CREATE_EVENT_FLIGHT,
  CREATE_EVENT_INFO,
  CREATE_EVENT_LODGING,
  CREATE_EVENT_TRANSPORTATION,
  UPDATE_EVENT_ACTIVITY,
  UPDATE_EVENT_FLIGHT,
  UPDATE_EVENT_INFO,
  UPDATE_EVENT_LODGING,
  UPDATE_EVENT_TRANSPORTATION,
  DELETE_CONTENT_POI
}



// WEBPACK FOOTER //
// src/graphql/Event/index.js